import React, { useContext, useEffect, useState } from 'react'
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { styled, Box, CardActionArea } from '@mui/material'
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';

import { Context as FilterContext } from '../context/FilterContext'
import { filterByTags } from '../utils/utils';
//import './image.module.css'

const StyledCard = styled(Card)(({ theme }) => ({
    '&:hover': {
        opacity: 0.9,
    },
  }));
  
const ProductsHome = ({ products, reset }) => {
    const { state } = useContext(FilterContext)

    const replaceLastOccurrence = (str, search, replacement) => {
        var lastIndex = str.lastIndexOf(search);
        return lastIndex === -1 ? str : str.slice(0, lastIndex) + replacement + str.slice(lastIndex + search.length);
    }
    
    const setMainProd = (item) => {
        item.image = replaceLastOccurrence(item.image,'_360x.','.');
        window.scrollTo(50, 50);
        localStorage.setItem("main_product", JSON.stringify(item))
        reset(true)
    }

    return (
        <div>
            <ResponsiveMasonry columnsCountBreakPoints={{ 500: 2, 750: 3, 900: 5, 1100: 7, 1300: 9 }}>
                <Masonry
                    columnsCount={5}
                    gutter="20px"
                    options={{
                        columnWidth: 1
                    }}
                >
                    {
                        filterByTags(products, state).map((product, i) => (
                            <StyledCard key={i}>
                                <CardActionArea onClick={() => setMainProd(product)}>
                                        <CardMedia
                                            component="img"
                                            image={product.image}
                                            />
                                </CardActionArea>
                            </StyledCard>
                        ))
                    }
                </Masonry>
            </ResponsiveMasonry>
        </div>
    )
}

export default ProductsHome